import React from 'react';

import { colors } from '@/const/colors';
import { IMAGE_BASE_URL } from '@/const/url';

const SpeedGuide = () => {
  return (
    <>
      <main className="flex flex-col w-full">
        <div className="flex flex-col items-center justify-center py-[46px]">
          <p className="text-grey-8 text-center mb-[10px] text-[14px]">차량을 즉시 처분해야 하나요?</p>
          <div className="text-grey-10 text-center font-semibold text-[20px] pb-[10px]">
            개인 딜러가 제시하는 금액 보다 <br />
            손해는 적고, 처분은 빠르게!
          </div>
          <div className="flex flex-col items-center justify-center sm680:px-8 sm360:px-8 sm280:px-6 py-6 rounded-[10px] bg-grey-1 gap-4">
            <div className="font-bold text-center text-[20px]">
              타사 견적 대비
              <br />
              <p className="text-primary-10">최대 300만원 더!</p>
            </div>
            <img src={`${IMAGE_BASE_URL}/graph.png`} alt="그래프 이미지" width={184} height={142} />
          </div>
          <div className="h-2 w-full bg-grey-1 mt-[50px]"></div>
          <div className="mt-[40px]">
            <div className="text-center justify-center font-semibold text-[20px] text-grey-10">
              매입 절차는
              <br className="hidden sm280:block" /> 이렇게 진행돼요
            </div>
            <div className="relative flex flex-col items-start gap-6 pt-6 pb-2 sm680:flex-row sm680:items-center sm680:justify-center sm680:gap-8">
              <div className="relative flex items-center sm680:flex-col sm680:items-center">
                <div className="flex items-center justify-center w-8 h-8 font-bold rounded-full bg-grey-3 text-grey-7">
                  1
                </div>
                <span className="ml-2 text-sm text-left text-grey-10 sm680:ml-0 sm680:mt-2 sm680:text-center">
                  직트럭 담당자와&nbsp;
                  <br className="hidden sm680:block" />
                  견적 상담
                </span>
                <div className="absolute w-[2px] h-full left-4 top-8 bg-grey-2 sm680:hidden"></div>
                <div className="absolute hidden w-16 h-[2px] sm680:block top-4 left-full bg-grey-2"></div>
              </div>
              <div className="relative flex items-center sm680:flex-col sm680:items-center">
                <div className="flex items-center justify-center w-8 h-8 font-bold rounded-full bg-grey-3 text-grey-7">
                  2
                </div>
                <span className="ml-2 text-sm text-left text-grey-10 sm680:ml-0 sm680:mt-2 sm680:text-center">
                  차량 실차 확인 후 최종 협의
                </span>
                <div className="absolute w-[2px] h-[75%] left-4 top-[35px] bg-grey-2 sm680:hidden"></div>
                <div className="absolute hidden w-16 h-[2px] sm680:block top-4 left-[80%] bg-grey-2"></div>
              </div>
              <div className="relative flex items-center sm680:px-2 sm680:flex-col sm680:items-center">
                <div className="flex items-center justify-center w-8 h-8 font-bold rounded-full bg-grey-3 text-grey-7">
                  3
                </div>
                <span className="ml-2 text-sm text-left text-grey-10 sm680:ml-0 sm680:mt-2 sm680:text-center">
                  차량 계약 및&nbsp;
                  <br className="hidden sm680:block" /> 필요 서류 준비
                </span>
                <div className="absolute w-[2px] h-full left-4 top-8 bg-grey-2 sm680:hidden"></div>
                <div className="absolute hidden w-16 h-[2px] sm680:block top-4 left-[80%] bg-grey-2"></div>
              </div>
              <div className="relative flex items-center sm680:flex-col sm680:items-center">
                <div className="flex items-center justify-center w-8 h-8 font-bold rounded-full sm680:px-4 bg-grey-3 text-grey-7">
                  4
                </div>
                <span className="ml-2 text-sm text-left text-grey-10 sm680:ml-0 sm680:mt-2 sm680:text-center">
                  잔금 처리 후&nbsp;
                  <br className="hidden sm680:block" />
                  차량 인도
                </span>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default SpeedGuide;
